module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/LezioneDodiciUnoPDF.d5c8358c.png";